import * as $ from "jquery";

export function init() {
	function closeAllPulldowns() {
		$('.js-pulldown-menu').removeClass('state-visible');
		$('.js-site-header-search').removeClass('state-zlow');
	}

	$('.js-pulldown-toggle').on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();
		let $parentNavItem = $(this).parents('.secondary-nav__item');

		$(this).siblings('.js-pulldown-menu').toggleClass('state-visible');

		$('.js-site-header-search').toggleClass('state-zlow');

		if($parentNavItem.length) {
			$parentNavItem.toggleClass('state-open');
		}
	});

	// TODO Create a global close-on-body click data attribute or selector
	$('body').on('click', closeAllPulldowns);

	$('.js-pulldown-option').on('click', function (e) {

		let text = $(this).text();

		let $pulldown = $(this).closest('.js-pulldown');

		$pulldown.find('.js-pulldown-selection').text(text);
		closeAllPulldowns();
	});
}



// WEBPACK FOOTER //
// ./js/PFF/modules/pulldowns.ts